module.exports = __webpack_public_path__ + "img/chevron-down.cf81a6a7.svg";